import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Layout from './layouts/Layout';
import Home from './pages/Home';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'slide',
    });

    // Fallback to hide loader if main.js timing is off
    const loader = document.getElementById("ftco-loader");
    if (loader) {
      setTimeout(() => {
        loader.classList.remove("show");
      }, 1);
    }

    // Initialize template scripts after React has rendered the DOM
    if (window.initTemplate) {
      setTimeout(() => {
        window.initTemplate();
      }, 500);
    }
  }, []);

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
